/**
 * @name: messageManagement.js
 * @description: 消息管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/message/notice/list',
    name: 'noticeManagement',
    component: () => import('@/views/message/notice/List'),
    meta: {
      title: '应用通知'
    }
  },
  {
    path: '/message/notice/add',
    name: 'noticeAdd',
    component: () => import('@/views/message/notice/Add'),
    meta: {
      title: '添加应用通知',
      parentRoutePath: 'noticeManagement'
    }
  },
  {
    path: '/message/sms/SMSQueueList',
    name: 'SMSQueueList',
    component: () => import('@/views/message/sms/SMSQueueList'),
    meta: {
      title: '消息列表',
    }
  },
  {
    path: '/message/sms/SMSRetryList',
    name: 'SMSRetryList',
    component: () => import('@/views/message/sms/SMSRetryList'),
    meta: {
      title: '重试列表',
    }
  },
];
